angular.module('jv.requisition.candidates.controller', [])
    .controller('ReqsCandidatesCtrl', ['$scope', 'Reqs', 'jvCandidatesService', 'jvSearchConfigService', '$window',
    function ($scope, Reqs, jvCandidatesService, jvSearchConfigService, $window) {
            // Private variable
            var options;
            sessionStorage.reqsId = $scope.params.id;
            $scope.candidateService = jvCandidatesService;
            $scope.configService = jvSearchConfigService;
            $scope.translations = i18n.candidateDetails;
            $scope.candidateStickyColumnsAndHeadersEnabled = $window.candidateStickyColumnsAndHeadersEnabled;

            $scope.flags.loading = false;
            $scope.requisitions.paging = {
                page: 0,
                pageLimit: 10
            };

            // Bootstrapping the Notes section.
            if ($scope.$parent.tabClicked === 'candidates') { // On click of tab
                // $scope.refresh(); Commenting for now as causing console error, Will add the method while doing integration
            } else if ($scope.activeTab('#/candidates')) { // On pagination or On Refresh
                options = angular.extend({
                    paginated: $scope.flags.paginated
                }, $scope.params);
                /*Restricting the request if params is empty*/
                if (!$.isEmptyObject($scope.params)) {
                    Reqs.details(options, function (requisition) {
                        angular.extend($scope.requisitions, requisition);
                        if ($scope.requisitions.forumBaseUrl) {
                            $scope.$root.forumBaseUrl = $scope.requisitions.forumBaseUrl;
                        }
                        $scope.params.id = $scope.requisitions.jobDetails.EId;
                        // $scope.refresh(); Commenting for now as causing console error, Will add the method while doing integration
                    });
                }
            }
        }
    ]);
